import React, { useState } from 'react';
import { useSearchParams } from 'react-router';
import LeadershipHeader from '../views/c-suite/LeadershipHeader';
import LeadershipSidebar from '../views/c-suite/LeadershipSidebar';
import LeadershipDashboardContent from '../views/c-suite/LeadershipDashboardContent';
import GovernanceMeetings from '../components/governance/GovernanceMeetingsNetBody';
import RiskOverview from '../components/risk/RiskOverview';
import ControlDeficiencies from '../components/internalControls/ControlDeficiencies';
import AnalyticsTab from '../components/monitoring/AnalyticsTab';
import IncidentInsights from '../components/incidenceReporting/IncidentInsights';
import ComplianceInsights from '../components/compliances/ComplianceInsights';
import AuditInsights from '../components/audits/AuditInsights';
import InsightsTab from '../components/capa/InsightsTab';


const LeadershipPage: React.FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    console.log('LeadershipPage rendering...');
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('view') || 'dashboard';

    const setActiveTab = (tab: string) => {
        setSearchParams({ view: tab });
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard':
                return <LeadershipDashboardContent activeMenu={activeTab} onNavigate={setActiveTab} />;
            case 'governance':
                return <GovernanceMeetings />;
            case 'risk':
                return <RiskOverview />;
            case 'internal-controls':
                return <ControlDeficiencies />;
            case 'monitoring':
                return <AnalyticsTab />;
            case 'incidence-reporting':
                return <IncidentInsights />;
            case 'compliances':
                return <ComplianceInsights />;
            case 'audits':
                return <AuditInsights />;
            case 'capa':
                return <InsightsTab />;
            default:
                return <LeadershipDashboardContent activeMenu={activeTab} onNavigate={setActiveTab} />;
        }
    };

    return (
        <div className="flex flex-col h-screen overflow-hidden">
            <LeadershipHeader onToggleSidebar={toggleSidebar} />
            <div className="c-suite-layout flex-1">
                <LeadershipSidebar
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                    isOpen={sidebarOpen}
                />
                <div className="c-suite-main-content">
                    <div className="c-suite-dashboard-container h-full overflow-auto">
                        {renderContent()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeadershipPage;
